import { render, staticRenderFns } from "./Profil.html?vue&type=template&id=d357bcba&"
import script from "./Profil.js?vue&type=script&lang=js&"
export * from "./Profil.js?vue&type=script&lang=js&"
import style0 from "./Profil.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports